import { constants } from '../../constants';

const styles = {
    container: {
        WebkitTransition: 'all 0.1s',
        alignItems: 'stretch',
        backgroundImage: 'url()',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
        marginRight: 30, // needed to keep the text from colliding with other sections beside it on the right
    },
    contentBodyText: {
        color: '#5C5C5C',
        fontFamily: 'Open Sans',
        fontSize: 16,
        fontWeight: '300',
        whiteSpace: 'pre-line'
    },
    mainTitle: {
        color: constants.color.primary || 'black',
    },
    mainTitleAlt: {
        color: constants.color.grey54 || 'black',
    },
    mainTitleContainer: {
        fontFamily: 'Open Sans',
        fontSize: 40,
        fontWeight: '700',
    },
    mainTitleOnly: {
        display: 'inline'
    },
    subTitle: {
        color: '#7B7B7B',
        fontFamily: 'Open Sans',
        fontSize: 25,
        fontWeight: '300',
        marginBottom: 10
    },
}

Object.freeze(styles);

export { styles as contentStyles };


// WEBPACK FOOTER //
// ./src/js/components/Content/styles.ts